import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue';
import { VipData } from '@/view/vip/supportScript';
import vipViewContent from './components/vipViewContent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipView',
  props: {
    dataSet: {},
    isTabView: { type: Boolean }
  },
  emits: ['vIPClaim', 'update:active'],
  setup(__props: any, { emit: __emit }) {


const active = ref(0);

const props = __props
const emit = __emit

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(vipViewContent, {
      "data-set": _ctx.dataSet,
      onVIPClaim: VIPClaim,
      active: active.value,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      "is-tab-view": _ctx.isTabView
    }, null, 8, ["data-set", "active", "is-tab-view"])
  ]))
}
}

})